import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toast";
import AuthServices from "../../../ApiServices/AuthServices";
import Api from "../../../ApiServices/MasterServices";
import { FaSpinner } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";

const Login = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const user = localStorage.getItem("user");
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [disableSubmitButtonM, setDisableSubmitButtonM] = useState(false);
  const recaptchaRef = React.useRef();

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user]);

  const getPermissionsWithRole = async (role_id) => {
    try {
      const res = await Api.getPermissionsByRoleID(role_id);
      if (res.status) {
        let prevIds = [];
        res.data.data.permissions.map((p) => {
          prevIds.push(p.permission_id);
        });
        localStorage.setItem(
          "user_permissions",
          JSON.stringify(res.data.data.permissions)
        );
        return true;
      } else {
        return false;
      }

    } catch (e) {
      console.log(e, "error in getPermissionsWithRole");
      return false;
    }
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    const body = {
      m_user_email: e.target.email.value,
      m_user_password: e.target.password.value,
      // captcha: recaptchaValue ? recaptchaValue : null
    };

    setDisableSubmitButton(true)

    AuthServices.Login(body)
      .then(async (response) => {
        const { data, status } = response;

        if (status == 200 && data.status) {
          toast.success(data.message);
          localStorage.setItem("user", JSON.stringify(data?.data?.user));
          localStorage.setItem("auth-token", data?.data?.token);

          setDisableSubmitButton(false)
          recaptchaRef.current?.reset();
        } else {
          recaptchaRef.current?.reset();
          toast.error(data.message);
          setDisableSubmitButton(false)
        }
      })
      .catch((error) => {
        recaptchaRef.current?.reset();
        // console.log("error=>",error)
        const msg = "Username or Password does not match, please try again";
        toast.error(msg);
        setDisableSubmitButton(false)
      });
  };

  return (
    <>
      {/* <ToastContainer delay={3000} position="top-right" /> */}
      {/* <div className="flex min-h-screen flex-col justify-center py-16 sm:px-6 lg:px-8 bg-slate-50 bg-[url('https://img.freepik.com/free-vector/digital-glowing-technology-lines-with-metwork-wire-mesh_1017-28404.jpg?w=2000&t=st=1712399538~exp=1712400138~hmac=9ddc67644f6c8971f1a45c9a75cfe8c0d86d64bf5c224a3b238b47e100193975')] "> */}
      <div className="flex min-h-screen flex-col justify-center py-16 sm:px-6 lg:px-8 bg-[#000] ">
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-[#151515] py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="text-center flex justify-center">
              <div className="py-1 px-6 rounded">
                <img
                  className="mx-auto h-28 w-auto"
                  src="https://static.wixstatic.com/media/a8379c_66819434229b49e3a66800c8c0b54789~mv2.png/v1/fill/w_220,h_240,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/a8379c_66819434229b49e3a66800c8c0b54789~mv2.png"
                  alt="Your Company"
                />
              </div>
            </div>
            <div className="p-4">
              <h2 className="text-center text-2xl font-medium tracking-tight text-gray-200">
                {/* Sign in to your account
                {/* { location.pathname === "/signUp" ? "Sign-Up to your account" : "Sign-In to your account"} */}
                Welcome Back
              </h2>
              {/* <p className="text-center text-sm text-gray-200">
                Please enter your details.
              </p> */}
            </div>

            <form className="space-y-6" onSubmit={(e) => handleSubmit(e)}>
              <div>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="text"
                    placeholder="Email"
                    required
                    className="text-white bg-[#222] block w-full appearance-none rounded-md border border-gray-800 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-pink-500 focus:outline-none focus:ring-pink-500 sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <div className="mt-1">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    placeholder="Password"
                    required
                    className="text-white bg-[#222]  block w-full appearance-none rounded-md border border-gray-800 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-pink-500 focus:outline-none focus:ring-pink-500 sm:text-sm"
                  />
                </div>
              </div>

              {/* <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6Ldx1s0pAAAAAM5pi4e67LPAHHxb1RHfvzWSDXF0"
              /> */}

              <div className="text-center">
                <button
                  type="submit"
                  className="bg-gradient-to-r from-[#11ffdb] to-[#0172fd] flex w-full justify-center rounded-md py-2 px-4 text-sm font-medium text-white shadow-sm"
                  disabled={disableSubmitButton}
                >
                  {(disableSubmitButton ? <FaSpinner color="gold" className="spinner" /> : "Sign-In")}
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
